// Live-updates the "Estás comprando: ... / Cantidad: ..." summary when the
// shopper changes a variant option or the quantity (typing or +/- buttons).
(function () {
  function getSelectedOptionValues() {
    var values = [];
    document.querySelectorAll('.variant-option input[type="radio"]:checked').forEach(function (input) {
      values.push(input.value);
    });
    document.querySelectorAll('.variant-option select').forEach(function (select) {
      if (select.value) values.push(select.value);
    });
    return values;
  }

  function getQuantity() {
    var input = document.querySelector('quantity-selector-component input[name="quantity"]');
    if (!input) return null;
    var value = parseInt(input.value, 10);
    return isNaN(value) ? 1 : value;
  }

  function updateSummary(root) {
    var variantEl = root.querySelector('[data-squishy-ps-variant]');
    if (variantEl) {
      var values = getSelectedOptionValues();
      variantEl.textContent = values.join(' / ');
    }

    var qtyEl = root.querySelector('[data-squishy-ps-qty-value]');
    var quantity = getQuantity();
    if (qtyEl && quantity !== null) {
      qtyEl.textContent = quantity;
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-squishy-purchase-summary]');
    if (!roots.length) return;

    function updateAll() {
      roots.forEach(updateSummary);
    }

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;
      if (target.closest('.variant-option') || target.closest('quantity-selector-component')) {
        updateAll();
      }
    });

    document.addEventListener('input', function (event) {
      var target = event.target;
      if (target && target.closest('quantity-selector-component')) {
        updateAll();
      }
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (target && target.closest('quantity-selector-component')) {
        requestAnimationFrame(updateAll);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
